import { useLocation } from '@tanstack/react-router'

export const useQueryParams = () => {
  const location = useLocation()
  return new URLSearchParams(location.searchStr)
}
